export enum LegalDocumentEnum {
  GeneralTerms = 'generalTerms',
  // PrivacyPolicy = 'privacyPolicy',
  // PrivacyPrinciples = 'privacyPrinciples',
  // CookiePolicy = 'cookiePolicy',
  // Subprocesses = 'subprocesses',
}
